module.exports = __webpack_public_path__ + "media/images/icons/media-stop-3c336ed2f47339c7f249b5ef5852b225.svg";